import { deepCopy } from '@portals/shared/common/utils';
import { TrackRoute } from '@portals/shared-frontend/components';

import { useBackend } from '@/hooks/useBackend';

import ApiPage from '../../components/ApiPage';
import { API_EXPLORER_TABS } from '../../content';

export default function CommercialApis() {
  const { data: apis, mutate } = useBackend('/apis/commercial');

  return (
    <ApiPage
      apiType={API_EXPLORER_TABS.Commercial}
      apis={apis}
      onApiFavouriteChange={(apiId, isFavorite) =>
        mutate((apis) => {
          if (apis) {
            const updatedApis = deepCopy(apis);
            const index = updatedApis.findIndex((api) => api.id === apiId);
            updatedApis[index]!.isFavorite = isFavorite;
            return updatedApis;
          }
          return;
        }, false)
      }
      title="Commercial APIs"
    >
      <TrackRoute name="Commercial APIs" path="/explorer/apis/commercial" type="commercial" />
    </ApiPage>
  );
}
